import React, { Component, Fragment } from "react";
import UsuarioForm from "../../../../Components/Admin/Usuarios/Form";

export default class PageAdminUsuarioForm extends Component {
    render() {
        return (
            <Fragment>
                <UsuarioForm {...this.props} />
            </Fragment>
        );
    }
}
